import React from "react";
import { Link } from "react-router-dom";

/** Shared org-feature upsell when a capability is off for the organization. */
const FeatureGate = ({
  icon,
  title,
  description,
  bullets,
  featureLabel,
  ctaTo = "/account/billing/",
  ctaLabel = "View plans",
  footer,
}) => (
  <div className="mx-auto max-w-lg px-4 py-10 text-center">
    <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-2xl bg-theme-secondary/40 ring-1 ring-theme-secondary">
      {icon}
    </div>
    <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
    <p className="mx-auto mt-3 max-w-md text-sm leading-6 opacity-70">
      {description}
    </p>
    <ul className="mx-auto mt-8 max-w-sm space-y-3 text-left text-sm">
      {bullets.map(({ icon: BulletIcon, text }) => (
        <li key={text} className="flex items-start gap-3">
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-theme-secondary/60 text-theme-primary ring-1 ring-theme-secondary">
            <BulletIcon className="h-4 w-4" aria-hidden="true" />
          </span>
          <span className="pt-1.5 opacity-70">{text}</span>
        </li>
      ))}
    </ul>
    <p className="mt-6 text-xs opacity-50">
      {footer || `${featureLabel} is included on Launch and higher plans.`}
    </p>
    <div className="mt-6">
      <Link
        to={ctaTo}
        className="inline-flex rounded-lg bg-theme-primary px-5 py-2.5 text-sm font-semibold text-theme-button transition hover:opacity-90"
      >
        {ctaLabel}
      </Link>
    </div>
  </div>
);

export default FeatureGate;
